export default {
  TimeoutPageTitle: 'Page timeout',
  TimeoutMessageMetaDescription: "The page timed out while loading.",
  TimeoutMessage: "This page timed out and could not be loaded. Please try again later.",
  NotFoundMessage: "Page not Found !!!"
};